import styled from 'styled-components';

export const CircularProgressWrapper = styled.div`
  position: absolute;
  z-index: 2;
`;
